// «2 декабря» / «December 2» — до какого дня действует Pro или когда следующее списание.
export const formatProDate = (iso: string, locale: string): string =>
  new Intl.DateTimeFormat(locale, { day: "numeric", month: "long" }).format(new Date(iso));
